module.exports = __webpack_public_path__ + "static/media/pages1.8d4dcc3b.JPG";